<div class="standalone-page">
    <div class="standalone-card">
        <img src="../../../assets/images/logo_sales_force_color_big.png" alt="" class="standalone-card__logo standalone-card__logo--wide" />
        <div class="standalone-card__title">Salesforce connected successfully.</div>
        <div class="standalone-card__text standalone-card__text--tight">Popup will close automatically</div>
    </div>
</div>
